module.exports = __webpack_public_path__ + "static/media/Logo__GEAppliances.3324bd8e.svg";